import { render, staticRenderFns } from "./_TagList.vue?vue&type=template&id=b1d79bb2"
import script from "./_TagList.vue?vue&type=script&lang=ts"
export * from "./_TagList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports